export default __webpack_public_path__ + "static/media/payu-logo.a38815a6.svg";